import { ReactNode } from 'react';

export type TabData = {
  id: string;
  label: string;
  panelId: string;
  title: string;
  content: ReactNode;
};

export const TAB_DATA: TabData[] = [
  {
    id: 'tab-1',
    label: 'Overview',
    panelId: 'panel-1',
    title: 'Overview',
    content: 'High-level snapshot of the study—sites, milestones, and current risks.',
  },
  {
    id: 'tab-2',
    label: 'Eligibility',
    panelId: 'panel-2',
    title: 'Eligibility',
    content: 'Inclusion/exclusion criteria with versioning and audit-ready change history.',
  },
  {
    id: 'tab-3',
    label: 'Documents',
    panelId: 'panel-3',
    title: 'Documents',
    content: 'SOPs, templates, and protocol amendments with e-sign and read-acknowledge.',
  },
  {
    id: 'tab-4',
    label: 'Timeline',
    panelId: 'panel-4',
    title: 'Timeline',
    content: 'Planned vs. actual for FPI, LPO, DB lock; variance alerts to keep on track.',
  },
];

export const TABS_STORY_DATA: TabData[] = [
  {
    id: 't1',
    label: 'One',
    panelId: 'p1',
    title: 'One',
    content: 'Panel one',
  },
  {
    id: 't2',
    label: 'Two',
    panelId: 'p2',
    title: 'Two',
    content: 'Panel two',
  },
  {
    id: 't3',
    label: 'Three',
    panelId: 'p3',
    title: 'Three',
    content: 'Panel three',
  },
];
